import React, { useEffect } from 'react';
import { InformationPanel, TextParagraph } from '../common/informationPanel/InformationPanel';
import { ScreenHeaderTitle } from '../common/screenHeader/ScreenHeaderTitle';
import { ButtonContainer } from '../common/buttonContainer/ButtonContainer';
import { Button, ButtonTheme } from '../common/button/Button';
import { useDecommissionResultContext } from '../../context/DecommissionContext';

export function DecommissionResult({
  startChatHandler,
  askAboutSomethingElseHandler,
  finishHandler,
  reportDecommission,
}: {
  startChatHandler: () => void;
  askAboutSomethingElseHandler: () => void;
  finishHandler: () => void;
  reportDecommission: () => Promise<void>;
}) {
  useEffect(() => {
    void reportDecommission();
  }, []);

  const { decommissionResult } = useDecommissionResultContext();

  const decommissionSuccessText: TextParagraph[] = [
    {
      text: decommissionResult.deviceId,
      lineBreak: false,
    },
  ];

  const decommissionFailText: TextParagraph[] = [
    {
      text: 'Please contact SST',
      lineBreak: false,
    },
  ];

  return (
    <>
      {decommissionResult.status === 'SUCCESS' ? (
        <>
          <ScreenHeaderTitle title={'Meter decommissioned'} />
          <p className="m-b-10">You can now remove this device:</p>
          <InformationPanel
            textArray={decommissionSuccessText}
            title={`${decommissionResult.deviceType} GUID`}
            background={true}
          />
          <ButtonContainer>
            <Button
              buttonId={'decommission-finish'}
              buttonText={'Finish'}
              buttonTheme={ButtonTheme.PRIMARY}
              onClickHandler={finishHandler}
            ></Button>
          </ButtonContainer>
        </>
      ) : (
        <>
          <ScreenHeaderTitle title={'Decommission process failed'} />
          <InformationPanel textArray={decommissionFailText} title={null} background={false} textAlign={'center'} />
          <ButtonContainer>
            <Button
              buttonId={'decommission-result-start-chat'}
              buttonText={'Start Chat'}
              buttonTheme={ButtonTheme.PRIMARY}
              onClickHandler={startChatHandler}
            ></Button>
            <Button
              buttonId={'decommission-result-ask-about-something-else'}
              buttonText={'Ask about something else'}
              buttonTheme={ButtonTheme.SECONDARY}
              onClickHandler={askAboutSomethingElseHandler}
            ></Button>
          </ButtonContainer>
        </>
      )}
    </>
  );
}
